'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerControl", {
    enumerable: true,
    get: function() {
        return TagPickerControl;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerControl = require("./useTagPickerControl");
const _renderTagPickerControl = require("./renderTagPickerControl");
const _useTagPickerControlStylesstyles = require("./useTagPickerControlStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerControl = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerControl.useTagPickerControl_unstable)(props, ref);
    (0, _useTagPickerControlStylesstyles.useTagPickerControlStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerControlStyles_unstable')(state);
    return (0, _renderTagPickerControl.renderTagPickerControl_unstable)(state);
});
TagPickerControl.displayName = 'TagPickerControl';
